export default {
  setConfig(Vue, config, val) {
    if (config && config.length > 0) {
      config.forEach((item, index) => {
        let value = false;
        if (val[index] === `true`) {
          value = true;
        }
        Vue.set(item, `selected`, value);
      });
    }
  }
};
